import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Address } from '../../../models/address.model';
import { GeoInfoRead } from '../../../models/geo-info-read.model';

@Component({
  selector: 'app-address-edit-mode',
  templateUrl: './address-edit-mode.component.html',
  styleUrls: ['./address-edit-mode.component.scss'],
})
export class AddressEditModeComponent implements OnChanges {
  @Input() addressInput: string = '';
  @Input() addressInputAutoCompletion!: Address[];
  @Input() cancelModal!: boolean;
  @Input() autocompletionCustomMessage: string | undefined;
  @Input() autocompleteSelectedAddress: Address | undefined;
  @Input() geoInfoRead!: GeoInfoRead | undefined;

  @Output() addressChanged = new EventEmitter();
  @Output() autocompletionSelected = new EventEmitter<string>();

  readonly addressInputCustomMessage =
    "L'adresse doit être choisie parmi les suggestions";
  newAddress!: string;

  addressForm = new FormGroup({
    addressInput: new FormControl(''),
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['addressInput']) {
      this.addressForm.controls.addressInput.setValue(this.addressInput);
    }
    this.resetFormWhenModalIsClosed(changes);
  }

  addressInputChanged(event: Event) {
    this.newAddress = (event.target as HTMLInputElement).value;
    this.addressChanged.emit(this.newAddress);
  }

  onAddressInputMouseEnter() {
    if (!this.autocompleteSelectedAddress) {
      this.newAddress =
        this.addressForm.controls.addressInput.getRawValue() ?? '';
      this.addressChanged.emit(this.newAddress);
    }
  }

  onAutocompletionSelected(address: string) {
    this.addressForm.controls.addressInput.setValue(address);
    this.autocompletionSelected.emit(address);
  }

  private resetFormWhenModalIsClosed(changes: SimpleChanges) {
    if (changes['cancelModal'] && !changes['cancelModal'].firstChange) {
      this.addressForm.controls.addressInput.setValue(this.addressInput);
      this.addressChanged.emit(this.addressInput);
    }
  }
}
